export default __webpack_public_path__ + "img/546695c3abd6e1869ffdda039d4b9a8e.svg";